module.exports = __webpack_public_path__ + "static/media/message_submit.a8f753d0.svg";